<div class="flex flex-row text-xs">
  <app-usercombi-from-to [userCombi]="userCombi"></app-usercombi-from-to>
  <div class="grow ml-5 pt-[1px] text-right">
    @if (userCombi.running) {
      <span class="usercombi-selection-lastrun" translate="PAGE_DASHBOARD_USERCOMBI_RUNNING"></span>
    }
    @if (!userCombi.running && userCombi.lastRunDateHoursAgo <= 4) {
      <span class="usercombi-selection-lastrun" translate="PAGE_DASHBOARD_USERCOMBI_LASTRUN_MINUTES"
            [translateParams]="{minutesAgo: userCombi.lastRunDateMinutesAgo}">
      <span class="inline-block rounded-full border-4 text-xs ml-1 animate-pulse"
            [class.border-combidesk-red]="userCombi.failedExecutionCount > 0"
            [class.border-combidesk-green]="userCombi.failedExecutionCount === 0"></span>
    </span>
    }
    @if (!userCombi.running && userCombi.lastRunDateHoursAgo > 4 && userCombi.lastRunDateDaysAgo <= 2) {
      <span class="usercombi-selection-lastrun" translate="PAGE_DASHBOARD_USERCOMBI_LASTRUN_HOURS"
            [translateParams]="{hoursAgo: userCombi.lastRunDateHoursAgo}">
      <span class="inline-block rounded-full border-4 text-xs ml-1 animate-pulse"
            [class.border-combidesk-red]="userCombi.failedExecutionCount > 0"
            [class.border-combidesk-green]="userCombi.failedExecutionCount === 0"></span>
    </span>
    }
    @if (!userCombi.running && userCombi.lastRunDateDaysAgo > 2) {
      <span class="usercombi-selection-lastrun" translate="PAGE_DASHBOARD_USERCOMBI_LASTRUN_DAYS"
            [translateParams]="{daysAgo: userCombi.lastRunDateDaysAgo}">
      <span class="inline-block rounded-full border-4 text-xs ml-1 animate-pulse"
            [class.border-combidesk-red]="userCombi.failedExecutionCount > 0"
            [class.border-combidesk-green]="userCombi.failedExecutionCount === 0"></span>
    </span>
    }
  </div>
</div>
